<button
  id="ot-sdk-btn"
  [class.cookie-settings-button__hidden]="isHidden"
  class="ot-sdk-show-settings"
>
  Cookie Settings
</button>
